export default "__VITE_ASSET__BxLewQvB__"